import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BenutzerService } from '../benutzer.service';
import { MessageService } from '../../../../services/message-service/message.service';
import { SwapUser, User } from '../benutzer';
import { LocalStorageService } from './../../../../services/local-storage/local-storage.service';
import { API_BASE_URL_SERVICE } from '../../../../kiene-core.config';
import { KieneSession } from '../../../../services/local-storage/kiene-session';
import { isLocalApiBaseUri } from '../../../../utils/is-local-api-base-uri';

@Component({
    selector: 'kiene-anmelden-als-anderer-benutzer-dialog',
    templateUrl: './anmelden-als-anderer-benutzer-dialog.component.html',
    styleUrls: ['./anmelden-als-anderer-benutzer-dialog.component.scss'],
})
export class AnmeldenAlsAndererBenutzerDialogComponent implements OnInit {
    AuthentifikationForm = new FormGroup({
        AuthentKey: new FormControl('', [Validators.required, Validators.pattern(/^\d{6}$/)]),
    });
    generating = false;
    /** Non-local: AuthKey was emailed. */
    twoFaGenerated = false;
    authID: any = null;
    isLoading = false;
    /** Local API → skip email 2FA (backend still gates on `dev_*` profile). */
    readonly isLocalApi: boolean;

    constructor(
        public dialogRef: MatDialogRef<AnmeldenAlsAndererBenutzerDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { user: User; currentuser: User },
        @Inject(API_BASE_URL_SERVICE) apiBaseUrl: string,
        private userService: BenutzerService,
        private messageService: MessageService,
        private localStorageService: LocalStorageService,
    ) {
        this.isLocalApi = isLocalApiBaseUri(apiBaseUrl);
    }

    ngOnInit(): void {}

    onGenerate2Fa() {
        if (this.isLocalApi) {
            return;
        }
        this.generating = true;
        const currentUser = this.data.currentuser;
        const targetUser = this.data.user;

        const swapToUser: SwapUser = {
            from_benutzer_id: currentUser.benutzer_id,
            to_benutzer: targetUser,
            authkey: null,
            authID: null,
        };

        this.userService.createAuthKey(swapToUser).subscribe(
            response => {
                this.authID = response;
                this.messageService.infoMessage('Auth Key wurde erfolgreich erstellt ');
                this.twoFaGenerated = true;
                this.generating = false;
            },
            error => {
                this.messageService.errorMessage('Authkey konnte nicht erstellt werden', error);
                this.generating = false;
            },
        );
    }

    closeDialog(): void {
        this.dialogRef.close();
    }

    /** Local: confirm direct swap without 2FA. */
    confirmLocalSwap(): void {
        if (!this.isLocalApi || this.isLoading) {
            return;
        }
        const targetId = Number(this.data.user?.benutzer_id);
        if (!targetId) {
            this.messageService.errorMessage('Ungültiger Zielbenutzer.', null);
            return;
        }
        this.isLoading = true;
        this.userService.swapUserDirect(targetId).subscribe({
            next: (response: KieneSession) => this.applySwappedSession(response),
            error: err => {
                this.isLoading = false;
                this.messageService.errorMessage('Fehler!', err);
            },
        });
    }

    // Dialog abschließen und die Verifikation ausführen (non-local 2FA).
    async safeAndCloseDialog() {
        const targetUser = this.data.user;

        if (this.isLocalApi) {
            this.confirmLocalSwap();
            return;
        }
        if (this.AuthentifikationForm.valid) {
            const currentUser = this.data.currentuser;
            const authkey = this.AuthentifikationForm.get('AuthentKey')?.value;

            const swapuser: SwapUser = {
                from_benutzer_id: currentUser.benutzer_id,
                to_benutzer: targetUser,
                authkey: authkey,
                authID: this.authID as any,
            };

            this.performUserSwap(swapuser);
        }
    }

    private performUserSwap(swapuser: SwapUser): void {
        this.isLoading = true;
        this.userService.swapUser(swapuser).subscribe({
            next: (response: KieneSession) => this.applySwappedSession(response),
            error: err => {
                this.isLoading = false;
                this.messageService.errorMessage('Fehler!', err);
            },
        });
    }

    private applySwappedSession(response: KieneSession): void {
        const currentsession = this.localStorageService.getCurrentUser();
        this.localStorageService.setCurrentUser(response);
        this.localStorageService.setCurrentClient(null, 'LoginService');
        const mandant = response.mandanten[0];
        this.localStorageService.setCurrentMandant(mandant);
        this.localStorageService.setSwappedUser(currentsession);
        location.reload();
    }
}
